"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.glMatrixSetup = void 0;
const gl_matrix_1 = require("gl-matrix");
/**
 * make sure we use the "right" matrix-array-type
 */
const glMatrixSetup = () => {
    // lets do NOT use the Float32Array !
    // .. we get problems with JSON.stringify and JSON.parse!
    // .. and normal arrays are way faster :)
    gl_matrix_1.glMatrix.setMatrixArrayType(Array);
};
exports.glMatrixSetup = glMatrixSetup;
//# sourceMappingURL=gl-matrix.setup.js.map